import React, { useEffect } from 'react';
import Main from 'pages/Layout/Main';

import PasswordInfo from '../Modules/Profile/PasswordInfo';
import UserInfo from '../Modules/Profile/UserInfo';
import { useGetProfileInfoQuery } from 'redux/slices/profile/userInfoApi';
import { useDispatch } from 'react-redux';
import {
  updateUserInfo,
  updateExistingUserInfo,
} from 'redux/slices/profile/UserInfoSlice';
const ProfileInfo = () => {
  const dispatch = useDispatch();
  const { data: profileInfo } = useGetProfileInfoQuery();

  useEffect(() => {
    const userInfo = {
      fullName: profileInfo?.data?.user?.fullName,
      taxNumber: profileInfo?.data?.user?.customer?.taxNumber,
      identityNumber: profileInfo?.data?.user?.customer?.identityNumber,
      telephone: profileInfo?.data?.user?.customer?.telephone,
      email: profileInfo?.data?.user?.email,
      username: profileInfo?.data?.user?.username,
      customerId: profileInfo?.data?.user?.customerId,
      userId: profileInfo?.data?.user?.rowUuid,
      statusTypeId: profileInfo?.data?.user?.statusTypeId,
      companyName: profileInfo?.data?.user?.customer?.name,
    };
    dispatch(updateUserInfo(userInfo));
    dispatch(updateExistingUserInfo(userInfo));
  }, [profileInfo]);
  return (
    <Main>
      <UserInfo
        fullName={profileInfo?.data?.user?.fullName}
        taxNumber={profileInfo?.data?.user?.customer?.taxNumber}
        identityNumber={profileInfo?.data?.user?.customer?.identityNumber}
        companyName={profileInfo?.data?.user?.customer?.name}
        telephone={profileInfo?.data?.user?.customer?.telephone}
        email={profileInfo?.data?.user?.email}
        username={profileInfo?.data?.user?.username}
      />
      <PasswordInfo />
    </Main>
  );
};

export default ProfileInfo;
